/* How it works: the steps collapse into an accordion on a phone and stay open
   on a desktop.

   The markup is the same at both sizes — a button inside each step's heading,
   with the body beside it — and only the behaviour changes, because swapping
   the elements around at a breakpoint would mean rebuilding the list on every
   resize. Above the breakpoint every step reports aria-expanded="true", which
   is the truth: the bodies are all showing. Below it, one is open at a time,
   for the same reason the artist index opens one row at a time — an open step
   is several lines, and all five at once is the wall of text the accordion is
   there to break up. */
(function () {
  var MOBILE = '(max-width: 640px)';

  function bind(root) {
    var mq = window.matchMedia(MOBILE);
    var buttons = root.querySelectorAll('.coart-studio__step-open');
    if (!buttons.length) return;

    function collapseAll() {
      buttons.forEach(function (button) {
        button.closest('.coart-studio__step').classList.remove('is-open');
        button.setAttribute('aria-expanded', 'false');
      });
    }

    function expandAll() {
      buttons.forEach(function (button) {
        button.closest('.coart-studio__step').classList.remove('is-open');
        button.setAttribute('aria-expanded', 'true');
      });
    }

    /* Called on load and whenever the query flips, so a phone rotated to
       landscape past 640px does not leave four steps hidden with no way to
       open them. */
    function sync() {
      if (mq.matches) collapseAll();
      else expandAll();
    }

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        if (!mq.matches) return;

        var step = button.closest('.coart-studio__step');
        var was = step.classList.contains('is-open');

        collapseAll();

        /* Clicking the open step closes it, which is why the state is read
           before everything is collapsed above. */
        if (!was) {
          step.classList.add('is-open');
          button.setAttribute('aria-expanded', 'true');
        }
      });
    });

    mq.addEventListener('change', sync);
    sync();
  }

  document.querySelectorAll('.coart-studio').forEach(bind);

  /* The theme editor swaps the section's markup in place, and script tags
     inserted that way never run again, so the new steps arrive unbound. */
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('.coart-studio').forEach(bind);
  });
})();
